import { lighten, styled, Typography } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'

const StyledDataGridBase = styled(DataGridPro)(({ theme }) => {
  const oddBackground = theme.palette.common.white
  const evenBackground = '#f7f7f7'
  const hoverBackground = lighten(theme.palette.info.main, 0.85)
  const selectedBackground = lighten(theme.palette.info.main, 0.8)
  const selectedHoverBackground = lighten(theme.palette.info.main, 0.75)

  return {
    '& .MuiDataGrid-columnHeader--pinnedLeft, & .MuiDataGrid-columnHeader--pinnedRight':
      {
        backgroundColor: theme.palette.background.default,
      },
    // Base striping
    '& .MuiDataGrid-row.odd': {
      backgroundColor: oddBackground,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: oddBackground,
      },
    },
    '& .MuiDataGrid-row.even': {
      backgroundColor: evenBackground,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: evenBackground,
      },
    },
    // Hover state
    '& .MuiDataGrid-row.odd:hover, & .MuiDataGrid-row.odd.Mui-hovered': {
      backgroundColor: `${hoverBackground} !important`,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: `${hoverBackground} !important`,
      },
    },
    '& .MuiDataGrid-row.even:hover, & .MuiDataGrid-row.even.Mui-hovered': {
      backgroundColor: `${hoverBackground} !important`,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: `${hoverBackground} !important`,
      },
    },
    // Selected state
    '& .MuiDataGrid-row.odd.Mui-selected': {
      backgroundColor: selectedBackground,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: selectedBackground,
      },
    },
    '& .MuiDataGrid-row.even.Mui-selected': {
      backgroundColor: selectedBackground,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: selectedBackground,
      },
    },
    // Selected + Hover
    '& .MuiDataGrid-row.odd.Mui-selected:hover, & .MuiDataGrid-row.odd.Mui-selected.Mui-hovered':
      {
        backgroundColor: `${selectedHoverBackground} !important`,
        '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
          backgroundColor: `${selectedHoverBackground} !important`,
        },
      },
    '& .MuiDataGrid-row.even.Mui-selected:hover, & .MuiDataGrid-row.even.Mui-selected.Mui-hovered':
      {
        backgroundColor: `${selectedHoverBackground} !important`,
        '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
          backgroundColor: `${selectedHoverBackground} !important`,
        },
      },
  }
})

export const StyledDataGrid =
  StyledDataGridBase as unknown as typeof DataGridPro

export const noResultsOverlay = () => {
  return (
    <Typography sx={{ mt: 3, opacity: 0.6 }} textAlign="center">
      No results
    </Typography>
  )
}
